module.exports = __webpack_public_path__ + "static/pic04-4ca8ef83237faf388b8aab3cd9d0919b.jpg";